<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large
                    @click="$router.push('/classes/online/index/')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش جلسه آنلاین</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="onlineSession.title" label="عنوان"></v-text-field>
          </v-col>
          <v-col cols="6" md="3" lg="3" sm="6">
            <v-select label="روز"
                      :items="[{text:'شنبه',value:1},{text:'یکشنبه',value:2},{text:'دوشنبه',value:3},{text:'سه شنبه',value:4},{text:'چهارشنبه',value:5},{text:'پنجشنبه',value:6},{text:'جمعه',value:7}]"
                      item-text="text" item-value="value"
                      color="black" v-model="onlineSession.day">
            </v-select>
          </v-col>
          <v-col cols="6" md="2" lg="2" sm="6">
            <vue-persian-datetime-picker
                type="datetime"
                color="black"
                v-model="onlineSession.starts_at" custom-input="#starts_at"
                auto-submit>
            </vue-persian-datetime-picker>
            <v-text-field label="تاریخ شروع کلاس" v-model="onlineSession.starts_at" id="starts_at" color="black">
            </v-text-field>
          </v-col>
          <v-col cols="6" md="2" lg="2" sm="6">
            <v-autocomplete label="کلاس"
                      :items="onlineClasses"
                      item-text="title" item-value="id"
                      color="black" v-model="onlineSession.online_class_id">
            </v-autocomplete>
          </v-col>
          <v-col cols="12">
            <v-autocomplete label="هنرجویان"
                      :items="students"
                      multiple
                      item-text="name" item-value="id"
                      color="black" v-model="onlineSession.student_ids">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "OnlineSessionEdit",
  components: {VuePersianDatetimePicker},
  data() {
    return {
      students: [],
      onlineClasses: [],
      onlineSession: {
        online_class_id: null,
        title: null,
        starts_at: null,
        day: null,
        student_ids: []
      }
    }
  },
  mounted() {
    this.getStudents()
    this.getOnlineClasses()
    this.onlineSession.online_class_id = this.$route.params.classId
    this.getOnlineSession()
  },
  methods: {
    getOnlineClasses() {
      let url = '/class/crud/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.onlineClasses = res.data.data.data
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getStudents() {
      let url = 'admin/student/index?per_page=1000'
      window.axios.get(url).then((res) => {
        this.students = res.data.data.data
        console.log(this.students)
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    getOnlineSession() {
      window.axios.get('session/crud/private/get/' + this.$route.params.id).then((res) => {
        this.onlineSession = res.data.data.online_session
        this.onlineSession.student_ids = res.data.data.student_ids
        this.onlineSession.starts_at = res.data.data.online_session.starts_at_fa
      })
    },
    update() {
      window.axios.post('session/crud/private/update/' + this.$route.params.id, this.onlineSession).then(() => {
        this.openSnackbar("کلاس مورد نظر با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
  }
}
</script>

<style scoped>

</style>